
import React, { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServiciosPage = lazy(() => import('../pages/servicios/page'));
const ProyectosPage = lazy(() => import('../pages/proyectos/page'));
const ContactoPage = lazy(() => import('../pages/contacto/page'));
const HormigonImpresoPage = lazy(() => import('../pages/servicios/hormigon-impreso/page'));
const HormigonDesactivadoPage = lazy(() => import('../pages/servicios/hormigon-desactivado/page'));
const HormigonPulidoPage = lazy(() => import('../pages/servicios/hormigon-pulido/page'));
const HormigonRalladoPage = lazy(() => import('../pages/servicios/hormigon-rallado/page'));
const PiscinasArelitePage = lazy(() => import('../pages/servicios/piscinas-arelite/page'));
const ProteccionesAcabadosPage = lazy(() => import('../pages/servicios/protecciones-acabados/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

/**
 * Helper to wrap lazy‑loaded components with a fallback.
 * This prevents rendering errors while the component is being loaded.
 */
const withSuspense = (Component: React.LazyExoticComponent<React.ComponentType<any>>) => (
  <Suspense fallback={null}>
    <Component />
  </Suspense>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: withSuspense(HomePage),
  },
  {
    path: '/servicios',
    element: withSuspense(ServiciosPage),
  },
  {
    path: '/servicios/hormigon-impreso',
    element: withSuspense(HormigonImpresoPage),
  },
  {
    path: '/servicios/hormigon-desactivado',
    element: withSuspense(HormigonDesactivadoPage),
  },
  {
    path: '/servicios/hormigon-pulido',
    element: withSuspense(HormigonPulidoPage),
  },
  {
    path: '/servicios/hormigon-rallado',
    element: withSuspense(HormigonRalladoPage),
  },
  {
    path: '/servicios/piscinas-arelite',
    element: withSuspense(PiscinasArelitePage),
  },
  {
    path: '/servicios/protecciones-acabados',
    element: withSuspense(ProteccionesAcabadosPage),
  },
  {
    path: '/proyectos',
    element: withSuspense(ProyectosPage),
  },
  {
    path: '/contacto',
    element: withSuspense(ContactoPage),
  },
  {
    path: '*',
    element: withSuspense(NotFound),
  },
];

export default routes;
